import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Slide,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeleteModal({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  subtitle = "This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false,
  lodingText="Deleting..."
  
}) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="delete-confirmation-dialog"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
          maxWidth: 420,
          width: "100%",
          mx: 2,
        },
      }}
    >
      <Box textAlign="center" py={2}>
        {/* Delete Icon */}
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            backgroundColor: "#fee",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <DeleteOutlineIcon sx={{ fontSize: 35, color: "#e74c3c" }} />
        </Box>

        {/* Title */}
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem", p: 0 }}>
          {title}
        </DialogTitle>

        {/* Subtitle */}
        <DialogContent sx={{ p: 0, mt: 1 }}>
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        </DialogContent>

        {/* Actions */}
        <DialogActions sx={{ mt: 4, justifyContent: "center", gap: 2, p: 0 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            size="large"
            sx={{
              minWidth: 120,
              textTransform: "none",
              fontWeight: 500,
            }}
            disabled={loading}
          >
            {cancelText}
          </Button>

          <Button
            onClick={handleConfirm}
            variant="contained"
            color="error"
            size="large"
            disabled={loading}
            sx={{
              minWidth: 120,
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 2,
            }}
          >
        {loading ? lodingText : confirmText} ✅

          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
